import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorSubCategory from '../../constants/errorSubCategory';
import { getTranslatedApprovalType, getTranslatedApprovalTypePlural } from '../../utils/translationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalErrorAlertI18nTitle(props) {
  const {
    approvalType,
    errorSubCategory
  } = props;
  const approvalTypeName = getTranslatedApprovalType(approvalType);
  const approvalTypeNamePlural = getTranslatedApprovalTypePlural(approvalType);
  const options = {
    approvalType: approvalTypeName
  };
  switch (errorSubCategory) {
    case ErrorSubCategory.ACTIVE_APPROVAL_ALREADY_EXISTS:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.ACTIVE_APPROVAL_ALREADY_EXISTS",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_IS_ALREADY_APPROVED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_IS_ALREADY_APPROVED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_IS_ALREADY_CANCELED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_IS_ALREADY_CANCELED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_IS_ALREADY_REJECTED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_IS_ALREADY_REJECTED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_REJECTIONS_GATED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_REJECTIONS_GATED",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_STEP_IS_ALREADY_APPROVED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_STEP_IS_ALREADY_APPROVED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_STEP_IS_ALREADY_REJECTED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVAL_STEP_IS_ALREADY_REJECTED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVALS_NOT_ENABLED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVALS_NOT_ENABLED",
          options: options
        });
      }
    case ErrorSubCategory.APPROVER_NOT_VALID:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.APPROVER_NOT_VALID",
          options: options
        });
      }
    case ErrorSubCategory.CAN_NOT_UPDATE_APPROVAL_IF_NOT_PENDING:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.CAN_NOT_UPDATE_APPROVAL_IF_NOT_PENDING",
          options: options
        });
      }
    case ErrorSubCategory.CAN_NOT_UPDATE_APPROVAL_REMOVING_APPROVED_STEPS:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.CAN_NOT_UPDATE_APPROVAL_REMOVING_APPROVED_STEPS",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_WAS_ALREADY_SENT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_WAS_ALREADY_SENT",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_RECIPIENT_NOT_SUPER_ADMIN:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_RECIPIENT_NOT_SUPER_ADMIN",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_CANNOT_BE_SENT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_CANNOT_BE_SENT",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_ALREADY_ENABLED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_ALREADY_ENABLED",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_GATED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_GATED",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_REQUESTER_IS_SUPER_ADMIN:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUEST_ENABLING_NOTIFICATION_REQUESTER_IS_SUPER_ADMIN",
          options: options
        });
      }
    case ErrorSubCategory.REQUESTER_NON_VALID_FOR_CANCELLATION:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUESTER_NON_VALID_FOR_CANCELLATION",
          options: options
        });
      }
    case ErrorSubCategory.REQUESTER_SAME_USER_AS_THE_APPROVER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.REQUESTER_SAME_USER_AS_THE_APPROVER",
          options: options
        });
      }
    case ErrorSubCategory.USER_IS_NOT_AN_APPROVER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.titleText.USER_IS_NOT_AN_APPROVER",
          options: {
            approvalType: approvalTypeNamePlural
          }
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalErrorAlert.titleText.default"
      });
  }
}
export function ApprovalErrorAlertI18nMessage(props) {
  const {
    approvalType,
    errorSubCategory
  } = props;
  const approvalTypeName = getTranslatedApprovalType(approvalType);
  const approvalTypeNamePlural = getTranslatedApprovalTypePlural(approvalType);
  const options = {
    approvalType: approvalTypeName
  };
  switch (errorSubCategory) {
    case ErrorSubCategory.ACTIVE_APPROVAL_ALREADY_EXISTS:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.ACTIVE_APPROVAL_ALREADY_EXISTS",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_IS_ALREADY_APPROVED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.APPROVAL_IS_ALREADY_APPROVED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVAL_IS_ALREADY_CANCELED_ERROR:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.APPROVAL_IS_ALREADY_CANCELED_ERROR",
          options: options
        });
      }
    case ErrorSubCategory.APPROVALS_NOT_ENABLED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.APPROVALS_NOT_ENABLED",
          options: options
        });
      }
    case ErrorSubCategory.APPROVER_NOT_VALID:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.APPROVER_NOT_VALID",
          options: options
        });
      }
    case ErrorSubCategory.CAN_NOT_UPDATE_APPROVAL_IF_NOT_PENDING:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.CAN_NOT_UPDATE_APPROVAL_IF_NOT_PENDING",
          options: options
        });
      }
    case ErrorSubCategory.CAN_NOT_UPDATE_APPROVAL_REMOVING_APPROVED_STEPS:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.CAN_NOT_UPDATE_APPROVAL_REMOVING_APPROVED_STEPS",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_WAS_ALREADY_SENT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_WAS_ALREADY_SENT",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_RECIPIENT_NOT_SUPER_ADMIN:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_RECIPIENT_NOT_SUPER_ADMIN",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_CANNOT_BE_SENT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_CANNOT_BE_SENT",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_ALREADY_ENABLED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_ALREADY_ENABLED",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_GATED:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_GATED",
          options: options
        });
      }
    case ErrorSubCategory.REQUEST_ENABLING_NOTIFICATION_REQUESTER_IS_SUPER_ADMIN:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUEST_ENABLING_NOTIFICATION_REQUESTER_IS_SUPER_ADMIN",
          options: options
        });
      }
    case ErrorSubCategory.REQUESTER_NON_VALID_FOR_CANCELLATION:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUESTER_NON_VALID_FOR_CANCELLATION",
          options: options
        });
      }
    case ErrorSubCategory.REQUESTER_SAME_USER_AS_THE_APPROVER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.REQUESTER_SAME_USER_AS_THE_APPROVER",
          options: options
        });
      }
    case ErrorSubCategory.USER_IS_NOT_AN_APPROVER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalErrorAlert.message.USER_IS_NOT_AN_APPROVER",
          options: {
            approvalType: approvalTypeNamePlural
          }
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalErrorAlert.message.default"
      });
  }
}